export const getFullName = (person) =>
  [person?.firstName, person?.lastName].filter(Boolean).join(" ").trim();

export const getChildName = (child, t) =>
  [child?.firstName, child?.lastName].filter(Boolean).join(" ").trim() ||
  t("common.unknown_child", { defaultValue: "Child" });

export const getChildKey = (childOrId) =>
  String(
    typeof childOrId === "object"
      ? childOrId?.id ?? childOrId?.uuid ?? ""
      : childOrId ?? "",
  );

export const getBirthDateValue = (child) =>
  child?.dateBirth || child?.dateOfBirth || child?.birthDate || child?.date_of_birth || "";

const getDateLocale = () => {
  const stored = typeof window !== "undefined" ? window.localStorage?.getItem("i18nextLng") : "";
  if (stored?.startsWith("nl")) return "nl-NL";
  if (stored?.startsWith("en")) return "en-US";
  return typeof navigator !== "undefined" && navigator.language ? navigator.language : "en-US";
};

export const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(getDateLocale(), {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const getChildAge = (child) => {
  const value = getBirthDateValue(child);
  if (!value) return null;
  const birthDate = new Date(value);
  if (Number.isNaN(birthDate.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age -= 1;
  return age >= 0 ? age : null;
};

export const maskBsn = (value) => {
  if (value === null || value === undefined) return "—";
  const raw = String(value).replace(/\s+/g, "");
  if (!raw) return "—";
  const masked = raw.replace(/.(?=.{3})/g, "•");
  return (masked.match(/.{1,3}/g) || [masked]).join(" ");
};
